/**
 * Constructs that should be hidden from report displays.
 * The data is still calculated and stored, just not shown to users.
 *
 * Empty as of INC-25597: the "questioning" construct was unmasked once its
 * items (Q219, Q999, Q216) were reverse coded in the API (INC-25609).
 */
export const HIDDEN_CONSTRUCTS: readonly string[] = [];

export const isConstructHidden = (construct: string): boolean => HIDDEN_CONSTRUCTS.includes(construct);
